import { setSearchTerm } from "../payTypesDataReducer";
import { useSearch } from "../../../../core/util/storeHooks";

export const usePayTypeSearch = () =>
  useSearch((s) => s.data.listing.payTypes.searchTerm, setSearchTerm);
